// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const transition: Styleguide["transition"] = {
    /* Store Custom Code - > */
    duration: {
        short: 200,
        regular: 300,
        long: 700,
    },
    /* <-- Majestic Custom Code */
};

export default transition;
